<template>
  <div>
    <div class="eventsList-item-image">
      <custom-nuxt-link
        :to="`/events/${event.code}/`"
        :class="displayTicketTop ? 'eventsList-item-image-small' : 'eventsList-item-image-normal'"
        class="padding alignCenter"
        @click.native="pushGtmData"
      >
        <common-lazy-load-image :ref="`lazyLoadImg${index}`" :image-object="event.eyecatch_image" :alt="event.eyecatch_image.alt" />
      </custom-nuxt-link>
      <div v-if="displayMjSelect(event)" class="eventsList-item-image-stamp">
        <common-lazy-load-image
          :image-url="'/img/stamp_mj-select.svg'"
          :image-object="{ width: 50, height: 50 }"
          :is-fixed-dimension="true"
          alt="mj-select"
          background-color="none"
        />
      </div>
    </div>
    <div class="eventsList-item-infor">
      <span v-if="areaName(event)" class="eventsList-item-infor-area">{{ areaName(event) }}</span>
      <span class="eventsList-item-infor-timer">{{ startAtFormat(event.start_at) }}</span>
    </div>
    <div class="eventsList-profile">
      <div class="eventsList-profile-title">{{ event.title }}</div>
      <div class="eventsList-profile-favButton">
        <fav-button
          :event="event"
          :bookmarked-user-count="bookmarkedUserCount"
          @add-bookmark="plusBookmarkedCount"
          @remove-bookmark="minusBookmarkedCount"
        />
      </div>
    </div>
    <div class="eventsList-ticket marginL2 marginB3">
      <div v-if="maleTicket(event)" class="bgMale eventsList-ticket-infor">
        <div class="eventsList-item-infor-ticket infoPeople">
          <icon :size="2.5" :class="{ marginLIcon: !displayTicketTop }" class="marginBIcon" icomoon="male" color="blueSky" />
          <div :class="{ marginL2: displayTicketTop }">
            <component :is="tag" :class="{ 'marginB-1': displayTicketTop }">{{ maleTicket(event).text }}</component>
            <component :is="tag"
              >{{ numberToCurrencyNotUnit(maleTicket(event).min_price) }}円{{ maleTicket(event).has_ticket_price_from ? '〜' : '' }}</component
            >
          </div>
        </div>
      </div>
      <div v-if="femaleTicket(event)" class="bgFemale eventsList-ticket-infor">
        <div class="eventsList-item-infor-ticket infoPeople">
          <icon :size="2.5" :class="{ marginLIcon: !displayTicketTop }" class="marginBIcon" icomoon="female" color="pinkDark" />
          <div :class="{ marginL2: displayTicketTop }">
            <component :is="tag" :class="{ 'marginB-1': displayTicketTop }">{{ femaleTicket(event).text }}</component>
            <component :is="tag"
              >{{ numberToCurrencyNotUnit(femaleTicket(event).min_price) }}円{{ femaleTicket(event).has_ticket_price_from ? '〜' : '' }}</component
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timeConverter, numberToCurrencyNotUnit } from '@/utils/converter'
import GTM from '@/utils/tracking/gtm'
import { GA4_SELECT_ITEM } from '@/utils/constants/ga4'
import MjSelectMixin from '@/utils/mixins/MjSelectMixin'
const FavButton = defineAsyncComponent(() => import('@/components/FavButton.vue'))
const CommonLazyLoadImage = defineAsyncComponent(() => import('@/components/CommonLazyLoadImage.vue'))
export default {
  components: { FavButton, CommonLazyLoadImage },
  mixins: [MjSelectMixin],
  props: {
    event: { type: Object, required: true, default: null },
    bookmarkedUserCount: { type: Number, default: 0, required: false },
    index: { type: Number, default: 0, required: false },
    displayTicketTop: { type: Boolean, default: false, required: false }
  },
  computed: {
    startAt() {
      return timeConverter(this.event.start_at).fullDateWithWeekDay
    },
    tag() {
      return this.displayTicketTop ? 'div' : 'span'
    }
  },
  methods: {
    numberToCurrencyNotUnit,
    areaName(event) {
      if (event.all_optional_prefectures_selected) return 'オンライン'
      if (event.online_event_type && event.online_event_type !== 'offline') return `${event.prefecture.name}その他`
      return event.area_name
    },
    plusBookmarkedCount() {
      this.$emit('plus-bookmark-count')
    },
    minusBookmarkedCount() {
      this.$emit('minus-bookmark-count')
    },
    femaleTicket(event) {
      return event.tickets && event.tickets.female
    },
    maleTicket(event) {
      return event.tickets && event.tickets.male
    },
    startAtFormat(startAt) {
      const timeConverterObj = timeConverter(startAt)
      return `${timeConverterObj.fullDateTimeSingleHourWithoutYear}〜`
    },
    pushGtmData() {
      GTM.sendEcommerceDataToGa(GA4_SELECT_ITEM, this.event, this.$store.myGender)
    }
  }
}
</script>

<style lang="scss" scoped>
.eventsList {
  margin-left: 1.6rem;
  @include flex;
  &-profile {
    display: grid;
    grid-template-columns: 80% 20%;
    grid-template-rows: auto;
    min-height: 4.2rem;
    margin-left: 0.8rem;
    margin-bottom: 0.5rem;
    &-favButton {
      @include flex;
      margin-bottom: 0.4rem;
    }
    &-title {
      color: $black-1a;
      font-weight: bold;
      font-size: 1.5rem;
      line-height: 1.4;
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  &-ticket {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: auto;
    min-height: 4rem;
    &-infor {
      height: 4rem;
      display: grid;
      align-items: center;
      &.bgMale {
        background: rgba($blue-sky, 0.15);
      }
      &.bgFemale {
        background: rgba($pink-pale, 0.15);
      }
    }
  }
  &-item {
    flex-direction: column;
    overflow: auto;
    width: 29rem;
    height: 27rem;
    border-radius: 0.3rem;
    background-color: $white;
    @media screen and (max-width: 320px) {
      width: 27rem;
    }
    &-image {
      position: relative;
      &-small {
        display: block;
        height: 9rem;
        margin: 1rem 0.7rem;
        img {
          max-height: 9rem;
          width: fit-content;
        }
      }
      &-normal {
        display: block;
        height: 12.3rem;
        margin: 1rem 0.7rem;
        img {
          max-height: 12.3rem;
          width: fit-content;
        }
      }
      &-stamp {
        position: absolute;
        bottom: 3px;
        left: 10px;
        width: 50px;
        height: 50px;
      }
    }
    &-infor {
      margin-left: 0.7rem;
      margin-bottom: 1rem;
      &.flex {
        display: flex;
        align-items: center;
      }
      &-area {
        @include textEllipsis;
        float: left;
        min-width: 6.1rem;
        max-width: 9.5rem;
        min-height: 2.2px;
        height: 2.2rem;
        padding: 0.5rem 0.1rem;
        border-radius: 3px;
        color: $white;
        font-size: 1rem;
        text-align: center;
        background-color: $gray-55;
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        &.fixWidth {
          width: 60px;
        }
      }
      &-timer {
        color: $black-1a;
        font-weight: bold;
        font-size: 1.1rem;
        padding-left: 0.3rem;
      }
      &-ticket {
        color: $black-1a;
        font-weight: bold;
        font-size: 1.2rem;
        &.infoPeople {
          display: grid;
          grid-template-columns: 20% 80%;
          grid-template-rows: auto;
          align-items: center;
        }
      }
    }
  }
}

.marginB-1 {
  margin-bottom: -3px;
}

.marginBIcon {
  margin-bottom: 0.4rem;
}

.marginLIcon {
  margin-left: 0.4rem;
}
</style>
